// Shared category taxonomy used by the header mega-menu and footer.
// Keep in sync with backend /app/backend/seed_data.py CATEGORIES.
export const NAV_CATEGORIES = [
  { slug: "beds", name: "Beds", sub_categories: ["King", "Queen", "Storage"] },
  { slug: "sofas-seating", name: "Sofas & Seating", sub_categories: ["Sofas", "Sofa Cum Beds", "Armchairs"] },
  { slug: "dining-sets", name: "Dining Sets", sub_categories: ["4-Seater", "6-Seater", "8-Seater"] },
  { slug: "chairs", name: "Chairs", sub_categories: ["Dining", "Accent"] },
  { slug: "tables", name: "Tables", sub_categories: ["Coffee", "Side", "Study"] },
  { slug: "wardrobes-storage", name: "Wardrobes & Storage", sub_categories: ["2-Door", "3-Door", "Sliding"] },
  { slug: "tv-units", name: "TV Units & Cabinets", sub_categories: ["Wall Unit", "Standalone"] },
  { slug: "bookshelves", name: "Bookshelves", sub_categories: ["Open", "Modular"] },
  { slug: "swatches", name: "Sample Swatches", sub_categories: ["Fabric Swatches", "Wood Swatches"] },
];
